var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslateDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11454 10.8279L7.99987 8.94254L9.88521 10.8279L10.8279 9.88521L8.94254 7.99987L10.8279 6.11454L9.88521 5.17188L7.99987 7.05721L6.11454 5.17188L5.17188 6.11454L7.05721 7.99987L5.17188 9.88521L6.11454 10.8279Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 14.6673C11.6757 14.6673 14.6663 11.6767 14.6663 8.00065C14.6663 4.32465 11.6757 1.33398 7.99967 1.33398C4.32367 1.33398 1.33301 4.32465 1.33301 8.00065C1.33301 11.6767 4.32367 14.6673 7.99967 14.6673ZM7.99967 2.66732C10.9403 2.66732 13.333 5.05998 13.333 8.00065C13.333 10.9413 10.9403 13.334 7.99967 13.334C5.05901 13.334 2.66634 10.9413 2.66634 8.00065C2.66634 5.05998 5.05901 2.66732 7.99967 2.66732Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateDisabled);
export default __webpack_public_path__ + "static/media/TranslateDisabled.c7b87e5edb36442e6af6a4118a8747d7.svg";
export { ForwardRef as ReactComponent };